import { NavLink, useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { SIDEBAR_SECTIONS } from "../data/resourcesData";
import styles from "../ResourcesLayout.module.css";

/**
 * ResourcesSidebar — Left navigation for documentation pages.
 *
 * Props:
 *   isOpen:   boolean   — Whether the mobile drawer is open
 *   onClose:  () => void — Callback to close the mobile drawer
 */
const ResourcesSidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  const handleNavClick = () => {
    // Close the mobile drawer when a link is clicked
    if (onClose) onClose();
  };

  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && (
        <div
          className={styles["sidebar-backdrop"]}
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      <aside
        className={`${styles["docs-sidebar"]} ${isOpen ? styles["docs-sidebar-open"] : ""}`}
        role="navigation"
        aria-label="Documentation navigation"
        id="resources-sidebar"
      >
        {/* Mobile close button */}
        <div className={styles["sidebar-mobile-header"]}>
          <span className={styles["sidebar-mobile-title"]}>Navigation</span>
          <button
            className={styles["sidebar-close-btn"]}
            onClick={onClose}
            aria-label="Close navigation"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <nav className={styles["sidebar-nav"]}>
          {SIDEBAR_SECTIONS.map((section) => (
            <div key={section.group} className={styles["sidebar-group"]}>
              <div className={styles["sidebar-group-label"]}>{section.group}</div>
              <ul className={styles["sidebar-list"]}>
                {section.items.map((item) => (
                  <li key={item.slug}>
                    <NavLink
                      to={item.path}
                      end={item.path === "/resources"}
                      className={({ isActive }) =>
                        `${styles["sidebar-link"]} ${isActive ? styles["sidebar-link-active"] : ""}`
                      }
                      onClick={handleNavClick}
                      id={`sidebar-link-${item.slug}`}
                    >
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Mobile-only actions (Explore Platform / Book a Demo) */}
          <div className={styles["sidebar-mobile-actions"]}>
            <div className={styles["sidebar-group-label"]}>Platform</div>
            <ul className={styles["sidebar-list"]}>
              <li>
                <Link to="/" className={styles["sidebar-link"]} onClick={handleNavClick}>
                  Explore Platform
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  className={styles["sidebar-link"]}
                  style={{ color: "#1a1a1a", fontWeight: "600" }}
                  onClick={() => {
                    toast.info("Coming soon — stay tuned!");
                    handleNavClick();
                  }}
                >
                  Book a Demo
                </button>
              </li>
            </ul>
          </div>
        </nav>
      </aside>
    </>
  );
};

export default ResourcesSidebar;
